export interface SampledSeriesData {
  name: string;
  data: { timestamp: number; value: number | null | undefined; date: string }[];
}

export interface ScatterSeriesData {
  name: string;
  data: { x: number; y: number; key?: string }[];
}

export interface BarPoint {
  name: string;
  y?: number;
  [key: string]: any;
}

export type BarSeries = BarPoint[];

export type ChartType = 'line' | 'scatter' | 'drawdown' | 'bar' | 'donut';

export const CHART_CONFIG = {
  MAX_SCATTER_POINTS: 5,
  MAX_LINE_POINTS: 12,
  MAX_BAR_CATEGORIES: 8,
  DRAWDOWN_NEGATIVE_THRESHOLD: 0.8,
  DRAWDOWN_MAX_VALUE: 5,
  DRAWDOWN_MIN_VALUE: -100,
  DEFAULT_FRACTION_DIGITS: 2,
  DONUT_MIN_SIGNIFICANT_PERCENTAGE: 0.5,
  BAR_SERIES_LABEL_START_CODE: 65, // ASCII code for 'A'
} as const;
